"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    baseRequirements: {
        'ap biology': 1,
        'ib biology': 1,
        'biology': 1,
        /* new courses added 2018-06-26 */
        'ib biology higher level': 2,
        'ib biology standard level': 2 //credit edit 2024
    },
    oneAdditionalCredit: {
        'integrated physics/chemistry': 1,
        'ap chemistry': 1,
        chemistry: 1,
        physics: 1,
        'ib chemistry i': 1,
        'ap physics 1': 1,
        'ib physics i': 1,
        'principles of technology': 1,
        /* new courses added 2018-06-26 */
        "ap physics 1: algebra based": 1,
        "ap physics 2: algebra based": 1,
        "ap physics c": 1,
        "ap physics c: electr&magnetism": 1,
        "ap physics c: mechanics": 1,
        "electricity and magnetism": 0.5,
        "ib chemistry higher level": 2,
        "ib chemistry standard level": 2,
        "ib physics higher level": 2,
        "ib physics standard level": 2,
        "modern physics": 1,
        "organic chemistry": 1,
        "science and tech": 1
    },
    oneAdditionalCreditB: {
        'environmental systems-envirsys': 1,
        chemistry: 1,
        physics: 1,
        'aquatic science': 1,
        astronomy: 1,
        'earth and space science': 1,
        'ap environmental science': 1,
        'advanced animal science': 1,
        'advanced plant and soil science': 1,
        'anatomy & physiology': 1,
        'medical microbiology': 1,
        pathophysiology: 1,
        'food science': 1,
        'forensic science': 1,
        biotechnology: 1,
        'advanced biotechnology': 1,
        'principles of technology': 1,
        'scientific research & design': 1,
        'engineering design and problem solving': 1,
        'engineering science': 1,
        'ib chemistry i': 1,
        'ap physics 1': 1,
        'ib physics i': 1,
        'ap chemistry': 1,
        /* new courses added 2018-06-26 */
        "ap physics 1: algebra based": 1,
        "ap physics 2: algebra based": 1,
        "ap physics c": 1,
        "ap physics c: electr&magnetism": 1,
        "ap physics c: mechanics": 1,
        "electricity and magnetism": 0.5,
        "ib biology higher level": 2,
        "ib biology standard level": 2,
        "ib chemistry higher level": 2,
        "ib chemistry standard level": 2,
        "ib design tech sl": 1,
        "ib envr sys & soc": 1,
        "ib physics higher level": 2,
        "ib physics standard level": 2,
        "modern physics": 1,
        "organic chemistry": 1,
        "planet earth": 1,
        "scien research & design iii": 1,
        "science and tech": 1
    }
};
//# sourceMappingURL=science.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/core/science.js
// module id = 449
// module chunks = 22